import React, { useEffect, useState, Fragment } from "react";
import CustomerQuote from "../../components/QuoteBuilder/CustomerQuote";
import QuotesComp from "../../components/QuoteBuilder/QuotesComp";
import { useSelector } from "react-redux";

const Quotes = (props) => {
	const { makeModels } = props;
	const [cars, setCars] = useState([]);
	const [drivers, setDrivers] = useState([]);
	const renewalData = useSelector((state) => state.RenewalData);

	useEffect(() => {
		if (renewalData) {
			setDrivers(renewalData.drivers);
			setCars(renewalData.cars);
		}
	}, [renewalData]);

	return (
		<div className="quotes general d-flex justify-content-center">
			<div className="otcontainer1 nopadding col otmb-4">
				<div className="col">
					<h1 className="otmt-2 otmb-4" style={{ color: "#00778a" }}>
						Quote Builder
					</h1>
				</div>
				<CustomerQuote cars={cars} drivers={drivers} makeModels={makeModels} />
				<hr className="softline l1 mt-2 otmt-2" />
				<div className="col">
					<h1 className="otmt-2 mb-5" style={{ color: "#00778a" }}>
						Quotes
					</h1>
				</div>
				<QuotesComp id={renewalData.customer_id} />
			</div>
		</div>
	);
};
export default Quotes;
